import { Button, Grid } from '@mui/material';
import { INDEX } from 'config/fe-routes';
import { useTranslation } from 'react-i18next';
import IosHome from 'react-ionicons/lib/IosHome';
import { redirectTo } from 'utils/route-helpers';
import { useIsScreenSizeMax } from 'utils/screen-size';

const HomeButton = (props) => {
  const { t } = useTranslation();
  const isMobileScreen = useIsScreenSizeMax('md');

  return (
    <Grid container justifyContent="center" {...props}>
      <Button
        fullWidth={isMobileScreen}
        variant="contained"
        color="primary"
        size="large"
        onClick={() => redirectTo(INDEX())}
        className="button-wide"
      >
        <IosHome className="home-icon" />
        {t('components.home-button.back-to-main-page')}
      </Button>
    </Grid>
  );
};

export default HomeButton;
